import React from 'react'

export const QuestionIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M9.963 9.9C10.1276 9.43217 10.4524 9.03767 10.88 8.78639C11.3075 8.53511 11.8102 8.44326 12.299 8.5271C12.7878 8.61094 13.2312 8.86507 13.5506 9.24447C13.8699 9.62387 14.0447 10.1041 14.044 10.6C14.044 12 11.944 12.7 11.944 12.7M12 15.5H12.007M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z"
			stroke="#BDBDBD"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
